 <!-- <div class="main-stepper">
    <div class="menu-back pt-3">
        <button mat-raised-button (click)="onClickOfGenericCancelButton($event)">
            <mat-icon class="me-1">keyboard_backspace</mat-icon>{{'Language.BackText' | translate}}
        </button>
    </div>
    <mat-stepper orientation="horizontal" [linear]="isLinear" #stepper>
        <mat-step>
            <ng-template matStepLabel>{{'Language.BasicDetailText' | translate}}</ng-template>
            <div class="">
                <div class="page-content">
                    <h2 class="heading1 mb-5">{{'Language.TransporterMasterTest' | translate}}</h2>
                    <h2 class="heading2">{{'Language.BasicDetailText' | translate}}</h2>
                    <div class="entry-forms w-55">
                        <div class="row">
                            <div class="col-md-6">
                                <label class="f-label"><span class="required">*</span>{{'Language.TransporterCodeText' |
                                    translate}}</label>
                                <mat-form-field class="full-width" appearance="outline">
                                    <input type="text" matInput name="transporterCode" maxlength="20"
                                        placeholder="Max (20)" [(ngModel)]="this.getEntryFormDataSource.transporterCode"
                                        (ngModelChange)="btnEvent($event)" />
                                </mat-form-field>
                            </div>
                            <div class="col-md-6">
                                <label class="f-label"><span class="required">*</span>{{'Language.TransporterNameText' |
                                    translate}}</label>
                                <mat-form-field class="full-width" appearance="outline">
                                    <input type="text" matInput name="transporterName" maxlength="25"
                                        placeholder="Max (25)" [(ngModel)]="this.getEntryFormDataSource.transporterName"
                                        (ngModelChange)="btnEvent($event)" />
                                </mat-form-field>
                            </div>
                            <div class="col-md-6">
                                <label class="f-label"><span class="required">*</span>{{'Language.TransporterIDText' |
                                    translate}}</label>
                                <mat-form-field class="full-width" appearance="outline">
                                    <input type="text" matInput name="transporterID" maxlength="15"
                                        placeholder="Max (15)" [(ngModel)]="this.getEntryFormDataSource.transporterID"
                                        (ngModelChange)="btnEvent($event)" />
                                </mat-form-field>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="mt-2 footer">
                    <div class="d-flex">
                        <div class="me-auto">
                        </div>
                        <div class="">
                            <button mat-raised-button color="primary" matStepperNext>{{'Language.NextText' |
                                translate}}</button>
                        </div>
                    </div>
                </div>
            </div>
        </mat-step>
        <mat-step>
            <ng-template matStepLabel>{{'Language.TransporterDetailText' | translate}}</ng-template>
            <div class="">
                <div class="page-content">
                    <h2 class="heading1 mb-4">{{'Language.TransporterMasterTest' | translate}}</h2>
                    <h2 class="heading2">{{'Language.TransporterDetailText' | translate}}</h2>
                    <div class="row">
                        <div class="col-md-12">
                            <div class="tabledesign transporttable">
                                <table mat-table class="mat-elevation-z8"
                                    [dataSource]="this.getEntryFormDataSource.ewbTransporter_Lines">
                                    <ng-container matColumnDef="sno">
                                        <th mat-header-cell *matHeaderCellDef>S. No. </th>
                                        <td mat-cell *matCellDef="let element ; let i=index">
                                            
                                        </td>
                                    </ng-container>
                                     <ng-container matColumnDef="mode" hidden>
                                        <th mat-header-cell *matHeaderCellDef>{{'Language.TransporterModeText' |
                                            translate}} </th>
                                        <td mat-cell *matCellDef="let element ; let i=index">
                                            <mat-form-field class="field-bottom-0" appearance="outline"
                                                (click)="onOpenDropDown(1,i)">
                                                <input type="text" name="mode" [(ngModel)]="element.mode"
                                                    value="element.mode" readonly>
                                                <img src="./assets/images/cfl.svg" matSuffix alt="" class="me-2">
                                            </mat-form-field>
                                        </td>
                                    </ng-container> 
                                    <ng-container matColumnDef="modeName">
                                        <th mat-header-cell *matHeaderCellDef>{{'Language.TransporterModeText' |
                                            translate}}</th>
                                        <td mat-cell *matCellDef="let element ; let i=index">
                                            <div class="pt-1">
                                                <mat-form-field class="field-bottom-0" appearance="outline">
                                                    <input type="text" placeholder="Search Transport Mode" matInput
                                                        [formControl]="myControlTransportMode" [value]=''
                                                        [matAutocomplete]="automode" [(ngModel)]="element.mode"
                                                        (input)="btnEvent($event)" />
                                                    <mat-autocomplete #automode="matAutocomplete">
                                                        <mat-option
                                                            *ngFor="let option of filteredOptionsTransportMode | async"
                                                            [value]="option.modeName"
                                                            (onSelectionChange)="OnOptionSelectedTransportMode(option,i)">
                                                            {{option.modeName}}
                                                        </mat-option>
                                                    </mat-autocomplete>
                                                </mat-form-field>
                                            </div>
                                        </td>
                                    </ng-container>
                                    <ng-container matColumnDef="vehicleType">
                                        <th mat-header-cell *matHeaderCellDef>{{'Language.VehicleTypeText' | translate}}
                                        </th>
                                        <td mat-cell *matCellDef="let element ; let i=index">
                                            <div class="pt-1">
                                                  <mat-form-field class="full-width field-bottom-0"
                                                        appearance="outline"  (click)="onOpenDropDown(2,i)">
                                                        <input type="text" matInput name="vehicleType" hidden
                                                            [(ngModel)]="element.vehicleType"
                                                            value="element.vehicleType">
                                                        <input type="text" matInput name="vehicleTypeName"
                                                            [(ngModel)]="element.vehicleTypeName"
                                                            value="element.vehicleTypeName" readonly>
                                                            <img src="./assets/images/cfl.svg" matSuffix alt="" class="me-2">
                                                    </mat-form-field>  
                                                 <mat-form-field class="field-bottom-0" appearance="outline">
                                                    <input type="text" placeholder="Search Vehicle Type" matInput
                                                        [formControl]="myControlVehicleType" [value]=''
                                                         [matAutocomplete]="i"
                                                        [(ngModel)]="element.vehicleTypeName"
                                                        (input)="btnEvent($event)" />
                                                    <mat-autocomplete #i="matAutocomplete">
                                                        <mat-option
                                                            *ngFor="let option of filteredOptionsVehicleType | async"
                                                            [value]="option.vehicleTypeName"
                                                            (onSelectionChange)="OnOptionSelectedVehicleType(option,i)">
                                                            {{option.vehicleTypeName}}
                                                        </mat-option>
                                                    </mat-autocomplete>
                                                </mat-form-field> 
                                            </div>
                                        </td>
                                    </ng-container>
                                    <ng-container matColumnDef="vehicleNo">
                                        <th mat-header-cell *matHeaderCellDef>{{'Language.VehicleNumberText' |
                                            translate}} </th>
                                        <td mat-cell *matCellDef="let element ; let i=index">
                                            <div class="pt-1">
                                                <mat-form-field class="full-width field-bottom-0" appearance="outline">
                                                    <input type="text" matInput name="vehicleNo" maxlength="15"
                                                        placeholder="Max (15)" [(ngModel)]="element.vehicleNo"
                                                        value="element.vehicleNo" (ngModelChange)="btnEvent($event)">
                                                </mat-form-field>
                                            </div>
                                        </td>
                                    </ng-container>
                                    <ng-container matColumnDef="lineNumber" hidden>
                                        <th mat-header-cell *matHeaderCellDef> {{'Language.LineNumberText' | translate}}
                                        </th>
                                        <td mat-cell *matCellDef="let element ; let i=index">
                                            <div class="pt-1">
                                                <mat-form-field class="field-bottom-0" appearance="outline">
                                                    <input type="text" matInput name="lineNumber"
                                                        value="element.lineNumber">
                                                </mat-form-field>
                                            </div>
                                        </td>
                                    </ng-container>
                                    <ng-container matColumnDef="delete">
                                        <th mat-header-cell *matHeaderCellDef class="text-center">
                                            {{'Language.ActionText' | translate}} </th>
                                        <td mat-cell *matCellDef="let element ; let i=index" class="text-center">
                                            <i-feather class="t-icon popinter pointer" name="trash-2"
                                                (click)="deleteRow(i)"> </i-feather>
                                        </td>
                                    </ng-container>
                                    <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
                                    <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
                                </table>
                            </div>
                            <div class="col-md-12 mt-3">
                                <button mat-stroked-button color="primary"
                                    (click)="addRow()">{{'Language.AddNewItemText' | translate}}</button>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="mt-2 footer">
                    <div class="d-flex">
                        <div class="me-auto">
                            <button #buttonSave mat-raised-button color="primary" (click)="onSave($event)">
                                {{ btnText | translate}}
                            </button>
                            <button mat-stroked-button color="primary"
                                (click)="onClickOfGenericCancelButton($event)">{{'Language.CancelText' |
                                translate}}</button>
                        </div>
                        <div class="">
                            <button mat-raised-button color="primary" matStepperPrevious>
                                <i-feather class="t-icon" name="chevron-left"> </i-feather>
                                {{'Language.PreviousText' | translate}}
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        </mat-step>
    </mat-stepper>
</div> -->








 <div class="">
    <fieldset [disabled]="(getFormMode == 0 && !canAdd) || (getFormMode == 1 && !canEdit)" class="view-mode-fieldset" style="border: none; padding: 0; margin: 0;">
    <div class="page-content">
        <h2 class="heading7">Transport Master</h2>
        
        <mat-card class="my-4">
            <mat-card-content>
                <h2 class="heading8">
                    Basic Detail
                </h2>
                <div class="entry-forms">
                    <div class="row">
                        <div class="col-md-6">
                            <div class="row">
                                <div class="col-md-12">
                                    <label class="f-label"><span class="required">*</span>{{'Language.TransporterCodeText' |
                                        translate}}</label>
                                    <mat-form-field class="full-width" appearance="outline">
                                        <input type="text" matInput name="transporterCode" maxlength="20"
                                            placeholder="Max (20)" [(ngModel)]="this.getEntryFormDataSource.transporterCode"
                                            (ngModelChange)="btnEvent($event)" />
                                    </mat-form-field>
                                </div>
                                <div class="col-md-12">
                                    <label class="f-label"><span class="required">*</span>{{'Language.TransporterIDText' |
                                        translate}}</label>
                                    <mat-form-field class="full-width" appearance="outline">
                                        <input type="text" matInput name="transporterID" maxlength="15"
                                            placeholder="Max (15)" [(ngModel)]="this.getEntryFormDataSource.transporterID"
                                            (ngModelChange)="btnEvent($event)" />
                                    </mat-form-field>
                                </div>
                            </div>
                        </div>
                        <div class="col-md-6">
                            <div class="row">
                                <div class="col-md-12">
                                    <label class="f-label"><span class="required">*</span>{{'Language.TransporterNameText' |
                                        translate}}</label>
                                    <mat-form-field class="full-width" appearance="outline">
                                        <input type="text" matInput name="transporterName" maxlength="25"
                                            placeholder="Max (25)" [(ngModel)]="this.getEntryFormDataSource.transporterName"
                                            (ngModelChange)="btnEvent($event)" />
                                    </mat-form-field>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
  
            </mat-card-content>
        </mat-card>
        
        <mat-card class="my-4">
            <mat-card-content>
              <h2 class="heading8">Transport Detail</h2>
              <div class="entry-forms">
                <div class="row">
                  <div class="col-md-12">
                    <div class="tabledesign transporttable">
                        <table mat-table class="mat-elevation-z8"
                            [dataSource]="this.getEntryFormDataSource.ewbTransporter_Lines">
                            <ng-container matColumnDef="sno">
                                <th mat-header-cell *matHeaderCellDef class="text-center">{{'Language.S.No.Text' | translate}} </th>
                                <td mat-cell *matCellDef="let element ; let i=index" class="text-center">
                                  {{i+1}}
                                </td>
                            </ng-container>
                            <ng-container matColumnDef="modeName">
                                <th mat-header-cell *matHeaderCellDef>{{'Language.TransporterModeText' |
                                    translate}} </th>
                                <td mat-cell *matCellDef="let element ; let i=index">
                                    <div class="pt-1">
                                        <mat-form-field class="field-bottom-0 mb-1" appearance="outline"
                                       >
                                        <input type="text" matInput name="modeName" [(ngModel)]="element.modeName"
                                            value="element.modeName" readonly  (click)="onOpenDropDown(1,i)">
                                        <img src="./assets/images/cfl.svg" matSuffix alt="" class="me-2"  (click)="onOpenDropDown(1,i)">
                                    </mat-form-field>
                                    </div>
                                </td>
                            </ng-container>
                            <!-- <ng-container matColumnDef="modeName">
                                <th mat-header-cell *matHeaderCellDef>{{'Language.TransporterModeText' |
                                    translate}}</th>
                                <td mat-cell *matCellDef="let element ; let i=index">
                                    <div class="pt-1">
                                        <mat-form-field class="field-bottom-0 mb-1" appearance="outline">
                                            <input type="text" placeholder="Search Transport Mode" matInput
                                                [formControl]="myControlTransportMode" [value]=''
                                                [matAutocomplete]="i" [(ngModel)]="element.mode"
                                                (input)="btnEvent($event)" />
                                            <mat-autocomplete #i="matAutocomplete">
                                                <mat-option
                                                    *ngFor="let option of filteredOptionsTransportMode | async"
                                                    [value]="option.modeName"
                                                    (onSelectionChange)="OnOptionSelectedTransportMode(option,i)">
                                                    {{option.modeName}}
                                                </mat-option>
                                            </mat-autocomplete>
                                        </mat-form-field>
                                    </div>
                                </td>
                            </ng-container> -->
                            <ng-container matColumnDef="vehicleType">
                                <th mat-header-cell *matHeaderCellDef>{{'Language.VehicleTypeText' | translate}}
                                </th>
                                <td mat-cell *matCellDef="let element ; let i=index">
                                    <div class="pt-1">
                                        <mat-form-field class="full-width field-bottom-0 mb-1" appearance="outline"
                                           >
                                            <input type="text" matInput name="vehicleType" hidden
                                                [(ngModel)]="element.vehicleType" value="element.vehicleType"  (click)="onOpenDropDown(2,i)">
                                            <input type="text" matInput name="vehicleTypeName"
                                                [(ngModel)]="element.vehicleTypeName"
                                                value="element.vehicleTypeName" readonly  (click)="onOpenDropDown(2,i)">
                                            <img src="./assets/images/cfl.svg" matSuffix alt="" class="me-2"  (click)="onOpenDropDown(2,i)">
                                        </mat-form-field>
                                        <!-- <mat-form-field class="field-bottom-0" appearance="outline">
                                            <input type="text" placeholder="Search Vehicle Type" matInput
                                                [formControl]="myControlVehicleType" [value]=''
                                                 [matAutocomplete]="i"
                                                [(ngModel)]="element.vehicleTypeName"
                                                (input)="btnEvent($event)" />
                                            <mat-autocomplete #i="matAutocomplete">
                                                <mat-option
                                                    *ngFor="let option of filteredOptionsVehicleType | async"
                                                    [value]="option.vehicleTypeName"
                                                    (onSelectionChange)="OnOptionSelectedVehicleType(option,i)">
                                                    {{option.vehicleTypeName}}
                                                </mat-option>
                                            </mat-autocomplete>
                                        </mat-form-field>  -->
                                    </div>
                                </td>
                            </ng-container>
                            <ng-container matColumnDef="vehicleNo">
                                <th mat-header-cell *matHeaderCellDef>{{'Language.VehicleNumberText' |
                                    translate}} </th>
                                <td mat-cell *matCellDef="let element ; let i=index">
                                    <div class="pt-1">
                                        <mat-form-field class="full-width field-bottom-0 mb-1" appearance="outline">
                                            <input type="text" matInput name="vehicleNo" maxlength="15"
                                                placeholder="Max (15)" [(ngModel)]="element.vehicleNo"
                                                value="element.vehicleNo" (ngModelChange)="btnEvent($event)">
                                        </mat-form-field>
                                    </div>
                                </td>
                            </ng-container>
                            <ng-container matColumnDef="lineNumber" hidden>
                                <th mat-header-cell *matHeaderCellDef> {{'Language.LineNumberText' | translate}}
                                </th>
                                <td mat-cell *matCellDef="let element ; let i=index">
                                    <div class="pt-1">
                                        <mat-form-field class="field-bottom-0" appearance="outline">
                                            <input type="text" matInput name="lineNumber"
                                                value="element.lineNumber">
                                        </mat-form-field>
                                    </div>
                                </td>
                            </ng-container>
                            <ng-container matColumnDef="delete">
                                <th mat-header-cell *matHeaderCellDef class="text-center">
                                    {{'Language.ActionText' | translate}} </th>
                                <td mat-cell *matCellDef="let element ; let i=index" class="text-center">
                                    <div class="d-flex  justify-content-center">
                                            <i-feather class="t-icon pointer me-2" name="trash-2"
                                                (click)="deleteRow(i)"></i-feather>
                                            <!-- <mat-icon class="pointer text-primary"
                                            (click)="addRow()">add_box</mat-icon> -->
                                        </div>
                                </td>
                            </ng-container>
                            <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
                            <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
                        </table>
                    </div>
                    <div class="col-md-12 mt-3">
                        <button mat-stroked-button color="primary"
                            (click)="addRow()">{{'Language.AddNewItemText' | translate}}</button>
                    </div>
                  </div>
                </div>
              </div>
            </mat-card-content>
          </mat-card>
    </div>
    </fieldset>
  
    <div class=" mt-2 footer">
        <div class="me-auto">
            <button *ngIf="(getFormMode == 0 && canAdd) || (getFormMode == 1 && canEdit)" #buttonSave mat-raised-button color="primary" (click)="onSave($event)">
                {{ btnText | translate}}
            </button>
            <button class="me-2" #buttonCancel mat-raised-button (click)="onClickOfGenericCancelButton($event)">
                {{'Language.CancelText' | translate}}
            </button>
        </div>
    </div>
  </div> 

  